import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MessageBubbleProps {
  message: string;
  timestamp: string;
  isUser: boolean;
  isTyping?: boolean;
}

const MessageBubble = ({ message, timestamp, isUser, isTyping }: MessageBubbleProps) => {
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-[75%] lg:max-w-[60%] ${isUser ? 'order-2' : 'order-1'}`}>
        <div
          className={`rounded-2xl px-4 py-3 ${
            isUser
              ? 'bg-primary text-primary-foreground rounded-br-sm'
              : 'bg-card border border-border text-foreground rounded-bl-sm shadow-warm'
          }`}
        >
          {isTyping ? (
            <div className="flex items-center gap-2">
              <div className="flex gap-1">
                <span className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                <span className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                <span className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
              </div>
              {/* UPDATE: Changed name here */}
              <span className="text-sm text-muted-foreground">Stillpoint is typing...</span>
            </div>
          ) : (
            <p className="text-sm lg:text-base leading-relaxed whitespace-pre-wrap">{message}</p>
          )}
        </div>
        <div className={`flex items-center gap-2 mt-1 px-2 ${isUser ? 'justify-end' : 'justify-start'}`}>
          <span className="text-xs text-muted-foreground font-mono">{timestamp}</span>
          {isUser && (
            <Icon name="CheckIcon" size={14} className="text-success" />
          )}
        </div>
      </div>
      {!isUser && (
        <div className="w-10 h-10 bg-accent/10 rounded-full flex items-center justify-center ml-3 flex-shrink-0">
          <Icon name="SparklesIcon" size={20} className="text-accent" />
        </div>
      )}
    </div>
  );
};

export default MessageBubble;